/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:600px){app-item-swiper[_ngcontent-%COMP%]     .listing{max-width:300px!important;min-width:300px!important}}@media (min-width:900px){.card-preview[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
